/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from "@/axios.js"

export default {
  getShipList({ commit }, payload) {
    return new Promise((resolve, reject) => {
      const baseURL = axios.defaults.baseURL == "http://211.236.62.51:7878" ? "http://211.236.62.51:7771" : "https://api1.pulda.net:7770";
      const requestConfig = { headers: { password: 'password777' } };
      axios.get(`${baseURL}/api/v3/payment/homepage/transaction_history_list`, requestConfig).then((response) => {
        if (response.data.result == 'success') {
          commit('SET_SHIP_LIST', response.data.data);
          resolve(response.data.data);
        }
        reject(response);
      }).catch((error) => {
        reject(error);
      });
    });
  },
  getShipInfo({ commit }, payload) {
    return new Promise((resolve, reject) => {
      const baseURL = axios.defaults.baseURL == "http://211.236.62.51:7878" ? "http://211.236.62.51:7771" : "https://api1.pulda.net:7770";
      const requestConfig = { headers: { password: 'password777' } };

      axios.get(`${baseURL}/api/v3/payment/homepage/transaction_history?id=` + payload, requestConfig)
        .then((response) => {
          if (response.data.result == 'success') {
            commit('SET_ACTIVE_SHIP', response.data.data);
            resolve(response.data.data);
          } else {
            reject(response);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  updateShipState({ dispatch }, payload) {
    return new Promise((resolve, reject) => {
      const baseURL = axios.defaults.baseURL == "http://211.236.62.51:7878" ? "http://211.236.62.51:7771" : "https://api1.pulda.net:7770";
      const requestConfig = { headers: { password: 'password777' } };
      axios.put(`${baseURL}/api/v3/payment/homepage/transaction_history/state`, payload, requestConfig)
        .then((response) => {
          if (response.data.result == 'success') {
            dispatch('getShipList');
            resolve(response.data);
          } else {
            reject(response);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

}